const addCloseButtonListenerMobileSimple = (mobileSimpleOffer) => {
    document.addEventListener("click", (e) => {
        mobileSimpleOffer = document.querySelector(".c-simple-mobile");
        const openButton = mobileSimpleOffer.querySelector(".c-simple-mobile__open_button");
        const simpleContent = mobileSimpleOffer.querySelector(".c-simple-mobile__content");

        if (e.target.closest(".c-simple-mobile__open_button") || e.target.closest(".c-simple-overlay")) {
            simpleContent?.classList.toggle("is-hidden");
            openButton?.classList.toggle("is-active");
            noScrollSimpleMobileToggle(mobileSimpleOffer);
        }
    });
}

const noScrollSimpleMobileToggle = (mobileSimpleOffer) => {
    const isMobile = window.innerWidth < 560;

    if (mobileSimpleOffer.classList.contains('c-simple-mobile--small') || !isMobile) {
        return;
    }

    document.body.classList.toggle("no-scroll");
    document.querySelector(".c-simple-overlay")?.classList.toggle("is-active");
};

(function() {
    const simpleOffer = document.querySelector(".c-simple");
    const mobileSimpleOffer = document.querySelector(".c-simple-mobile");
    let isShown = false;

    if (!getCookie("simpleOfferClose") && simpleOffer) {
        const simpleClose = document.querySelector(".c-simple__close");

        window.addEventListener("scroll", function() {
            const st = window.pageYOffset || document.documentElement.scrollTop;

            if (st > 650) {
                simpleOffer.classList.add("active");
            }
        });

        simpleClose?.addEventListener("click", function() {
            simpleOffer.classList.add("animated");
            simpleOffer.classList.add("fadeOut");
            simpleOffer.classList.remove("active");
            isOpened = true;

            setCookie("simpleOfferClose", true, 1, "/");
        });
    }

    if (!mobileSimpleOffer || getCookie("simpleOfferMobileShown")){
        return;
    }

    const addClassOnScroll = (mobileSimpleOffer, scrollThreshold) => {
        const scrollPosition = window.scrollY;
        const windowHeight = window.innerHeight;
        const documentHeight = document.body.scrollHeight;
        const isMobile = window.innerWidth < 560;
        mobileSimpleOffer = document.querySelector(".c-simple-mobile");

        const scrollPercentage = scrollPosition / (documentHeight - windowHeight);

        if (scrollPercentage >= scrollThreshold && !isShown && isMobile) {
            mobileSimpleOffer.classList.add("is-active");
            noScrollSimpleMobileToggle(mobileSimpleOffer);
            isShown = true;
            setCookie("simpleOfferMobileShown", true, 1, "/");
            document.documentElement.style.paddingBottom = "3rem";
        }
    }

    const mobileSimpleOfferSetup = (mobileSimpleOffer) => {
        const scrollThreshold = 0.5;
        const debouncedAddClassOnScroll = debounce(addClassOnScroll, 300);

        window.addEventListener("scroll", () => {
            debouncedAddClassOnScroll(mobileSimpleOffer, scrollThreshold);
        });
    };

    const debounce = (func, delay) => {
        let timeoutId;

        return function (...args) {
            const context = this;

            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => func.apply(context, args), delay);
        };
    }

    mobileSimpleOfferSetup(mobileSimpleOffer);
    addCloseButtonListenerMobileSimple(mobileSimpleOffer);
})();
